import {
  ComponentIcon,
  EpicIcon,
  ReleaseIcon,
  SprintIcon,
} from "app/components/Icons";
import StoryIcon from "app/components/Icons/StoryIcon";
import React from "react";
import { TicketGroup, ITickets } from "../Tickets/types";
import {
  IPlanningViewsGroup,
  ISelectedPlanningTile,
  PlanningTileId,
  PlanningViewBy,
} from "./types";

export const getPlanningTileId = (
  viewBy: PlanningViewBy,
  group: IPlanningViewsGroup,
): PlanningTileId => {
  if (group.isUnassigned) return `${viewBy}-unassigned`;
  return group.id ?? `${viewBy}-${group.name}`;
};

export const getSelectedPlanningGroup = (
  viewBy: PlanningViewBy,
  groups: IPlanningViewsGroup[],
  selectedTile: ISelectedPlanningTile | null,
): IPlanningViewsGroup | null => {
  if (!selectedTile || selectedTile.id === "backlog") return null;
  if (viewBy !== PlanningViewBy.EPICS && viewBy !== PlanningViewBy.STORIES) {
    return null;
  }

  return (
    groups.find(
      (group) => getPlanningTileId(viewBy, group) === selectedTile.id,
    ) ?? null
  );
};

export function filterTicketGroupsByTicketIds(
  groups: TicketGroup[],
  ticketIds: string[],
  ticketCache: Record<string, ITickets>,
): TicketGroup[] {
  const idSet = new Set(ticketIds);

  const filterGroup = (group: TicketGroup): TicketGroup => {
    const filteredTicketIds = group.tickets.filter((id) => idSet.has(id));
    const filteredSubGroups = (group.subGroups ?? []).map(filterGroup);

    const filteredList = filteredTicketIds
      .map((id) => {
        const fromList = group.ticketsList?.find((ticket) => ticket._id === id);
        return fromList ?? ticketCache[id];
      })
      .filter(Boolean)
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    return {
      ...group,
      tickets: filteredTicketIds,
      ticketsList: filteredList,
      subGroups: filteredSubGroups,
    };
  };

  return groups.map(filterGroup);
}

export const getPlanningTypeIcon = (type: PlanningViewBy) => {
  switch (type) {
    case PlanningViewBy.COMPONENTS:
      return React.createElement(ComponentIcon, { size: 20 });
    case PlanningViewBy.EPICS:
      return React.createElement(EpicIcon);
    case PlanningViewBy.STORIES:
      return React.createElement(StoryIcon);
    case PlanningViewBy.SPRINTS:
      return React.createElement(SprintIcon, { size: 20 });
    case PlanningViewBy.NEXT_RELEASES:
      return React.createElement(ReleaseIcon, { size: 20 });
    case PlanningViewBy.PAST_RELEASES:
      return React.createElement(ReleaseIcon, { size: 20 });
    default:
      return null;
  }
};
